module.exports = __webpack_public_path__ + "img/user.9afc90d6.svg";